import React from "react";
import "./Spinner.css";
import { CommonLoading } from "react-loadingg";

const Spinner = () => {
  return (
    <>
      <div id="divBlock" className="block" style={{ display: "none" }}>
        <div className="">
          <div className="">
            <CommonLoading />
          </div>
        </div>
      </div>
    </>
  );
};

export default Spinner;
